import { useSignupData } from '../useSignupData';
import { useSignupSectionNavigation } from '../useSignupSectionNaivgation';

export const useAccessCodeMatchedStep = () => {
  const {
    isEligibilityCheckRequired: isEligibilityVerificationRequired,
    isHospitalCaregiverEnabled,
    isUserInvitedCaregiver,
  } = useSignupData();
  const { navigateToNextStep } = useSignupSectionNavigation();

  const submit = () => {
    if (isUserInvitedCaregiver) {
      const nextStep = isEligibilityVerificationRequired
        ? 'ConditionalEligibilityCheck'
        : 'CaregiverProfileCreation';
      navigateToNextStep(nextStep);
      return;
    }

    if (isHospitalCaregiverEnabled) {
      navigateToNextStep('UserTypeSelection');
      return;
    }

    const nextStep = isEligibilityVerificationRequired
      ? 'ConditionalEligibilityCheck'
      : 'MemberProfileCreation';
    navigateToNextStep(nextStep);
  };

  return { submit };
};
